import { DateTime } from 'luxon'

export const getStartDateTypeValue = (type: string) => {
  switch (type) {
    case 'isSpecified':
      return false
    case 'isAccepted':
      return true
    default:
      return undefined
  }
}

export const getStartDateTypeValueToDisplay = (type?: boolean) => {
  switch (type) {
    case true:
      return 'isAccepted'
    case false:
      return 'isSpecified'
    default:
      return ''
  }
}

export const formatAzureOfferStartDate = (date: string | null) =>
  date
    ? DateTime.fromISO(date)
        .startOf('month')
        .toFormat('yyyy-MM-dd')
        .toLocaleString()
    : ''

export const formatAzureOfferEndDate = (date: string | null) =>
  date
    ? DateTime.fromISO(date)
        .endOf('month')
        .toFormat('yyyy-MM-dd')
        .toLocaleString()
    : ''
